module.exports = __webpack_public_path__ + "static/media/logistics.12c266f4.svg";